<template>
    <answers ref="answers"
             code_question_group="GQ26"
             danger_code="MCAL14"
             :unique_category="true"
             control_question="QCAL162"
             :control_answer="true"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
